import request from "@/router/axios";

export const manualDetect = (data) => {
  return request({
    url: "/api/produce/coal-overstock-warning/manual-detect",
    method: "post",
    data,
  });
};

export const pushWarning = (data) => {
  return request({
    url: "/api/produce/coal-overstock-warning/push",
    method: "post",
    data,
  });
};

export const getUserList = (params) => {
  return request({
    url: "/api/produce/blade-user/select/userList",
    method: "get",
    params,
  });
};
